import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../utils/contexts/UserContext";
import CustomSvg from "../svgs/CustomSvg";
import { IoMdNotifications } from "react-icons/io";
import { IoLockClosed } from "react-icons/io5";
import { GoInfo } from "react-icons/go";
import { HiUsers } from "react-icons/hi";
import { BsBank, BsChat } from "react-icons/bs";
import { RiLogoutBoxRLine } from "react-icons/ri";
import avatar from "../../assets/images/userProfile3.png";
import { MdEdit } from "react-icons/md";
import { BsArrowLeft } from "react-icons/bs";
import { FaGift } from "react-icons/fa"; // <-- Add this import
import { path } from "pixi.js";

const navOptions = [
  {
    label: "Notification",
    icon: <IoMdNotifications size={20} color="#6499FF" />, 
    path: "/notifications-settings"
  },
  {
    label: "Security",
    icon: <IoLockClosed size={20} color="#6499FF" />, 
    path: "/user-profile/security"
  },
  {
    label: "Help",
    icon: <GoInfo size={20} color="#6499FF" />, 
    path: "/user-profile/help"
  },
  {
    label: "Invite Friends",
    icon: <HiUsers size={20} color="#6499FF" />, 
    path: "/user-profile/invite-friends"
  },
  {
    label: "Add Bank",
    icon: <BsBank size={20} color="#6499FF" />, 
    path: "/user-profile/add-bank"
  },
  {
    label: "Referral",
    icon: <FaGift size={20} color="#6499FF" />,
    path: "/user-profile/referrals",
    celebrityOnly: true
  },
  {
    label: "Chat with Us",
    icon: <BsChat size={20} color="#6499FF" />,
    path: "/user-profile/chat-with-us",
  }

];

function UserProfile() {
  const { user } = useContext(UserContext) || {};
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    sessionStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-[#130828] flex flex-col items-center py-8 px-4">
      <div className="flex justify-between items-center w-full max-w-md relative mb-8">
        <button
          className="mb-8"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <BsArrowLeft width={20} height={20} color="#fff" />
        </button>
        <h2 className="text-white text-2xl font-bold mb-8">Profile</h2>
        <button
          className="mb-6 p-3 bg-[#2972FE1A]/10 text-white rounded-lg font-semibold hover:bg-[#2972FE1A]/10 transition"
          onClick={() => navigate("/user-profile")}
        >
          <MdEdit size={15} color="#FFB1E7" />
        </button>
      </div>
      <div className="flex flex-row rounded-2xl px-6 pt-6 w-full max-w-md mb-8 shadow-lg">
        <div>
          <img
            src={user?.avatar || avatar}
            alt="User avatar"
            className="rounded-full object-cover mb-4 border-2 border-[#6499FF]"
            style={{
              borderRadius: "100%",
              width: "clamp(64px, 20vw, 120px)",
              height: "clamp(64px, 20vw, 120px)",
              minWidth: 64,
              minHeight: 64,
              maxWidth: 120,
              maxHeight: 120,
            }}
          />
        </div>
        <div className="flex flex-col justify-center ml-4">
          <div className="text-white text-lg capitalize font-semibold mb-1">
            { user?.username || "John Doe"}
          </div>
          <div className="text-gray-400 text-xs md:text-sm mb-1">
            {user?.email || "noemail@gmail.com"}
          </div>
          <div className="text-gray-400 text-sm">
            {user?.country || "Nigeria"}
          </div>
        </div>
      </div>
      <div className="w-full max-w-md rounded-2xl px-4 shadow-lg">
        <hr className="border-gray-600 mb-4" />
        <ul className="space-y-2">
          {navOptions
            .filter(
              (opt) =>
                !opt.celebrityOnly ||
                user?.accountType === "celebrity" ||
                user?.isCelebrity === true ||
                user?.role === "celebrity"
            )
            .map((opt, idx) => (
              <li key={opt.label}>
                <button
                  className="w-full flex items-center gap-4 p-3 rounded-lg hover:bg-[#23203A] transition text-left"
                  onClick={() => navigate(opt.path)}
                >
                  <span>{opt.icon}</span>
                  <span className="text-white text-base font-medium capitalize">{opt.label}</span>
                </button>
                <hr className="border-gray-600 mb-4" />
              </li>
            ))}
          <li>
            <button
              className="w-full flex items-center gap-4 p-3 rounded-lg hover:bg-[#23203A] transition text-left"
              onClick={handleLogout}
            >
              <span><RiLogoutBoxRLine size={20} color="#FF1843" /></span>
              <span className="text-white text-base font-medium capitalize">Logout</span>
            </button>
          </li>
        </ul>
      </div>
      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <>
          <div className="fixed w-100 inset-0 z-40  backdrop-blur-sm transition-all duration-300" />
          <div className="fixed inset-x-0 bottom-0 z-50 flex items-end justify-center">
            <div className="bg-[#fff] rounded-t-2xl px-6  py-10 w-full  shadow-xl flex flex-col items-center ">
              <span><RiLogoutBoxRLine size={36} color="#BD3193" /></span>
              <div className="text-[#3D3030] text-lg font-semibold mb-4 text-center">Are you sure want to logout?</div>
              <div className="flex gap-4 w-full mt-2">
                <button
                  className="flex-1 py-2 rounded-lg border border-[#BD3193] text-[#BD3193] font-semibold hover:bg-gray-700 transition"
                  onClick={() => setShowLogoutModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="flex-1 py-2 rounded-lg bg-[#BD3193] text-white font-semibold hover:bg-[#be1a34] transition"
                  onClick={confirmLogout}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default UserProfile;
